var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shopShareMain",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.removeDialog($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "content",
          staticStyle: { width: "80%", position: "relative", "z-index": "999" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "40px",
                "text-align": "center",
                position: "relative"
              }
            },
            [
              _c("img", {
                staticStyle: {
                  position: "absolute",
                  left: "calc(50% - 20px)",
                  top: "0",
                  width: "40px",
                  height: "40px"
                },
                attrs: { src: "static/images/product/icon_close.png" },
                on: { click: _vm.removeDialog }
              })
            ]
          ),
          _vm._v(" "),
          _c("img", {
            ref: "post",
            staticStyle: {
              position: "absolute",
              width: "100%",
              top: "50px",
              left: "0"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              staticStyle: { position: "absolute" }
            },
            [_c("div", { ref: "qrCodeImg" })]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }